import { useTranslation } from 'next-i18next';
import styles from '@features/cms/components/categories/CategoryGalleryBlock/components/ActiveFiltersChips/ActiveFiltersChips.styles';
import Button from '@components/Button/Button';
import CategoryGalleryFiltrationState from '@features/cms/components/categories/CategoryGalleryBlock/mobx/state/CategoryGalleryFiltrationState';
import CategoryGalleryStore from '@features/cms/components/categories/CategoryGalleryBlock/mobx/store/CategoryGalleryStore';
import Icon from '@components/icons/Icon';
type PropsType = {
  categoryStore: CategoryGalleryStore;
};
const ActiveFiltersChips = ({
  categoryStore
}: PropsType) => {
  const {
    selectedFiltersState,
    setSelectedFiltersState
  } = categoryStore;
  const {
    t
  } = useTranslation('filters');
  const handleRemoveFilter = (attributeCode: string, valueCode: string) => {
    if (!selectedFiltersState) return;
    const tmpState = new CategoryGalleryFiltrationState([...selectedFiltersState.attributes]);
    tmpState.deselectValue(attributeCode, valueCode);
    setSelectedFiltersState(tmpState.attributes);
  };
  const handleResetFilters = () => {
    if (!selectedFiltersState) return;
    const tmpState = new CategoryGalleryFiltrationState([...selectedFiltersState.attributes]);
    tmpState.deselectAllValues();
    setSelectedFiltersState(tmpState.attributes);
  };
  if (!selectedFiltersState || selectedFiltersState.getValuesCount() === 0) return null;
  return <div sx={styles.activeFiltersContainer}>
      <div sx={styles.activeFilters}>
        {selectedFiltersState.attributes.map(selectedFilter => selectedFilter.values.map(selectedValue => <div sx={styles.filterChip} key={selectedValue.code}>
              <span>{selectedValue.name}</span>
              <Button variant="iconOnly" onClick={() => handleRemoveFilter(selectedFilter.code, selectedValue.code)}>
                <Icon icon="Close3" size="24px" />
              </Button>
            </div>))}
        <Button variant="link" onClick={handleResetFilters} addSx={styles.activeFiltersButton}>
          <p>
            {t('resetAllFilters')} ({selectedFiltersState.getValuesCount()})
          </p>
        </Button>
      </div>
    </div>;
};
export default ActiveFiltersChips;